let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i8hiG")).then(() => parcelRequire('yTrVP'));